import {
  SalesAreaPriceLine,
  useDeleteSalesAreaPriceLineMutation,
  useFetchSalesAreaPriceLinesQuery,
} from "../../api/priceLineApi";
import {
  Box,
  Button,
  Collapse,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
} from "@mui/material";
import { Add } from "@mui/icons-material";
import { TableRowSkeleton } from "../../../../old/beheer/views/Upsell/modernTS/TableRowSkeleton";
import React from "react";
import { useCreateSalesAreaPriceLine } from "../../hooks/useCreateSalesAreaPriceLine";
import { BlockUserInput } from "@jamezz/react-components";
import { usePagination } from "../../../../old/beheer/views/Upsell/modernTS/JUI/Pagination/usePagination";
import { Pagination } from "../../../../old/beheer/views/Upsell/modernTS/JUI/Pagination/Pagination";

export default function SalesAreaPriceLinesView({ salesAreaId }: { salesAreaId: number }) {
  const pagination = usePagination();
  const { data, isFetching, isSuccess } = useFetchSalesAreaPriceLinesQuery({
    salesAreaId,
    pagination: { page: pagination.page, perPage: pagination.perPage },
  });

  const createPriceLine = useCreateSalesAreaPriceLine();

  return (
    <Paper sx={{ width: 1 }}>
      <Toolbar sx={{ display: "grid", gap: 2, pt: 2 }}>
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Button
            color={"success"}
            onClick={async () => {
              await createPriceLine();
            }}
            variant={"contained"}
          >
            <Add /> Add price line
          </Button>
        </Box>

        {/*<Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>*/}
        {/*  <TextField label="Filter by salesarea"></TextField>*/}
        {/*</Box>*/}
      </Toolbar>
      <TableContainer sx={{ maxWidth: "100%" }}>
        <Table size={"small"}>
          <TableHead>
            <TableRow>
              {/*<TableCell padding="checkbox">*/}
              {/*  <Checkbox />*/}
              {/*</TableCell>*/}
              <TableCell sx={{ fontWeight: 800 }}>#</TableCell>
              <TableCell sx={{ fontWeight: 800 }}>Title</TableCell>
              <TableCell sx={{ fontWeight: 800 }}>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {isFetching ? (
              <>
                <TableRowSkeleton cols={4} />
                <TableRowSkeleton cols={4} />
                <TableRowSkeleton cols={4} />
              </>
            ) : isSuccess && data != null ? (
              data.data.map((priceLine) => <Row key={priceLine.id} priceLine={priceLine} />)
            ) : null}
          </TableBody>
        </Table>
      </TableContainer>

      <Collapse in={Boolean(data?.links.next || data?.links.prev || pagination.perPage != 10)}>
        <Pagination paginationResponse={data} {...pagination} />
      </Collapse>
    </Paper>
  );
}

function Row({ priceLine }: { priceLine: SalesAreaPriceLine }) {
  const [deletePriceLine] = useDeleteSalesAreaPriceLineMutation();
  const myDelete = BlockUserInput.useWrapPromise(deletePriceLine);

  return (
    <TableRow key={priceLine.id}>
      {/*<TableCell padding="checkbox">*/}
      {/*  <Checkbox />*/}
      {/*</TableCell>*/}
      <TableCell>{priceLine.id}</TableCell>
      <TableCell>{priceLine.title}</TableCell>
      <TableCell sx={{ display: "flex", gap: 2 }}>
        {/*<Button variant="contained" size="small" onClick={() => setOpen((v) => !v)}>*/}
        {/*  Quick edit*/}
        {/*</Button>*/}
        <Button
          color={"primary"}
          onClick={() => {
            myDelete({ id: priceLine.id });
          }}
          size={"small"}
          variant={"contained"}
        >
          Delete
        </Button>
      </TableCell>
    </TableRow>
  );
}
